import React from "react";
import Helmet from "react-helmet";
import config from "../../data/SiteConfig";
import Layout from "../layout";
import AvatarLinks from "../components/Avatar/AvatarLinks";
import avatar_photo from "../../static/avatar.png";


/** @jsx jsx */
import { Styled, jsx } from "theme-ui";

class Index extends React.Component {
  render() {
    const { avatar } = config;
    return (
      <Layout>
        <Helmet title={config.siteTitle} />

        <div sx={{ display: 'grid', gridGap: 4, gridTemplateColumns: ['auto', '200px auto'], marginTop: `120px`, marginBottom: `30px`}}>
          <div sx={{ textAlign: `center`, float: `left`, marginTop: `28px` }}>
            <img src={avatar_photo} sx={{ width: 165, borderRadius: `5px` }} />
            <Styled.h1 sx={{ color: `text` }}>
              <Styled
                sx={{
                  fontWeight: `normal`,
                  fontSize: 32,
                  color: `text`,
                  textDecoration: `none`,
                }}
              >
                Amin Haeri
              </Styled>

              <Styled
                sx={{
                  fontWeight: `normal`,
                  fontSize: 18,
                  color: `text`,
                  textDecoration: `none`,
                  marginTop: `10px`
                }}
              >
                امین حائری
              </Styled>

              <Styled
                sx={{
                  fontWeight: `normal`,
                  fontSize: 18,
                  color: `primary`,
                  textDecoration: `none`,
                  marginTop: `20px`
                }}
              >
                Applied ML Scientist
              </Styled>

            </Styled.h1>

            <AvatarLinks />
          </div>

          <div sx={{ textAlign: `left`, float: `right` }}>
            <Styled.p>
              I am an Applied Machine Learning Scientist with interests in machine learning, large language models, information retrieval, and scientific computing. I enjoy building AI systems that combine research with practical applications, from developing new models to deploying them in production.
            </Styled.p>
              
            <Styled.p> 
              I currently work at <a href = "https://www.td.com/ca/en/personal-banking" target = "_blank" sx={{ color: `primary`, textDecoration: `none`, ":hover": {bg: `muted`, borderRadius: `5px` }}}>TD Bank</a>, where I develop AI and machine learning solutions for financial risk management. My recent work focuses on retrieval-augmented generation (RAG), embedding models, agentic AI systems, and information retrieval. Before joining TD, I was a Postdoctoral Researcher at the <a href = "https://www.uchicago.edu" target = "_blank" sx={{ color: `primary`, textDecoration: `none`, ":hover": {bg: `muted`, borderRadius: `5px` }}}>University of Chicago</a>, where I worked with Prof. <a href = "https://engineering.nyu.edu/faculty/juan-de-pablo" target = "_blank" sx={{ color: `primary`, textDecoration: `none`, ":hover": {bg: `muted`, borderRadius: `5px` }}}>Juan de Pablo</a> on graph neural networks for scientific simulations. Prior to that, I worked as a Software Developer at <a href = "https://www.cm-labs.com" target = "_blank" sx={{ color: `primary`, textDecoration: `none`, ":hover": {bg: `muted`, borderRadius: `5px` }}}>CM Labs Simulations</a>, developing simulation software for heavy equipment and robotics.
            </Styled.p>

            <Styled.p>
              I received my Ph.D. in Computer Engineering from Concordia University in 2021 under the supervision of Prof. <a href = "http://users.encs.concordia.ca/~kskoniec/" target = "_blank" sx={{ color: `primary`, textDecoration: `none`, ":hover": {bg: `muted`, borderRadius: `5px` }}}>Krzysztof Skonieczny</a>. My doctoral research focused on machine learning methods for physics-based simulations of robot–terrain interactions and granular materials. I also hold B.Sc. and M.Sc. degrees, both with honors, in Aerospace Engineering from Amirkabir University of Technology and Sharif University of Technology.
            </Styled.p>

            {/* <Styled.p>
              My <strong>resume</strong> can be downloaded from <a href = "https://drive.google.com/uc?export=download&id=1Iw9f2iiypI0obJ7tPCWyiPkf0GrbDYTJ" sx={{ color: `primary`, textDecoration: `none`, ":hover": {bg: `muted`, borderRadius: `5px` }}}>here</a>.
            </Styled.p> */} 
            
            <Styled.p>
              {/* Email:&ensp; me <strong>at</strong> aminhaeri <strong>dot</strong> com */}
              {/* Email:&ensp; me@aminhaeri.com */}
              me <strong>at</strong> aminhaeri <strong>dot</strong> com
            </Styled.p>
            
          </div>
        </div>


        <div sx={{ display: 'grid', gridGap: 4, gridTemplateColumns: ['auto', 'auto auto auto'] }}>
          <div sx={{ textAlign: `left`, float: `left`}}>
            <Styled.h1>Education</Styled.h1>
            <Styled.li sx={{ textAlign: 'left', fontSize: 20, listStyleType: `square` }}>Postdoc in ML, U of Chicago, 2021-22</Styled.li>
            <Styled.li sx={{ textAlign: 'left', fontSize: 20, listStyleType: `square` }}>PhD in Comp, Concordia U, 2017-21</Styled.li>
            <Styled.li sx={{ textAlign: 'left', fontSize: 20, listStyleType: `square` }}>MSc in Aero, Sharif U, 2015-17</Styled.li>
            <Styled.li sx={{ textAlign: 'left', fontSize: 20, listStyleType: `square` }}>BSc in Aero, Amirkabir U, 2011-15</Styled.li>
          </div>

          <div sx={{ textAlign: `left`, float: `left`}}>
            <Styled.h1>Interests</Styled.h1>
            <Styled.li sx={{ textAlign: 'left', fontSize: 20, listStyleType: `square` }}>Machine Learning</Styled.li>
            <Styled.li sx={{ textAlign: 'left', fontSize: 20, listStyleType: `square` }}>Generative Deep Learning</Styled.li>
            <Styled.li sx={{ textAlign: 'left', fontSize: 20, listStyleType: `square` }}>Agentic Workflows</Styled.li>
            <Styled.li sx={{ textAlign: 'left', fontSize: 20, listStyleType: `square` }}>Computational Methods</Styled.li>
          </div>
          
          <div sx={{ textAlign: `left`, float: `left`}}>
              <Styled.h1>News</Styled.h1>

              <Styled.li sx={{ textAlign: 'left', fontSize: 20, listStyleType: `square` }}>
                <small><b>2024 May:</b></small> Presentation at <a href = "https://2024.ieee-icra.org/" target = "_blank" sx={{ color: `primary`, textDecoration: `none`, ":hover": {bg: `muted`, borderRadius: `5px` }}}>ICRA Conference</a>
              </Styled.li>

              <Styled.li sx={{ textAlign: 'left', fontSize: 20, listStyleType: `square` }}>
                <small><b>2021 April:</b></small> Presentation at <a href = "https://ascelibrary.org/doi/abs/10.1061/9780784483374.006" target = "_blank" sx={{ color: `primary`, textDecoration: `none`, ":hover": {bg: `muted`, borderRadius: `5px` }}}>ASCE Earth&Space</a>
              </Styled.li>

              <Styled.li sx={{ textAlign: 'left', fontSize: 20, listStyleType: `square` }}>
                <small><b>2021 March:</b></small> Best Paper Award in Software and Computing track at <a href = "https://aeroconf.org" target = "_blank" sx={{ color: `primary`, textDecoration: `none`, ":hover": {bg: `muted`, borderRadius: `5px` }}}>IEEE Aerospace</a>
              </Styled.li>

              {/* <Styled.li sx={{ textAlign: 'left', fontSize: 20, listStyleType: `square` }}>
                <small><b>2020 Oct:</b></small> Presentation at <a href = "https://www.iaarc.org/publications/2020_proceedings_of_the_37th_isarc/efficient_numerical_methods_for_accurate_modeling_of_soil_cutting_operations.html" target = "_blank" sx={{ color: `primary`, textDecoration: `none`, ":hover": {bg: `muted`, borderRadius: `5px` }}}>ISARC Conference</a>
              </Styled.li> */}
          </div>

        </div>

      </Layout>
    );
  }
}

export default Index;
